import { useTranslation } from "react-i18next";

import { Spacer, Columns, Column, Arrange, Skeleton, Typography } from "@aviary";
import { l } from "@emerson/locales/i18n";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";

import { SkeletonProductActions } from "./ProductActions/SkeletonProductActions";

import * as styles from "./SingleProductDetails.styles";
const SkeletonSingleProductDetails = () => {
  const { t } = useTranslation();

  const { desktop, phoneLarge, tablet } = useBreakpoints();

  const colWidth = phoneLarge.lessThan ? 12 : undefined;
  const imageColumnWidth = desktop.greaterThan ? 7 : colWidth;
  const productInfoColWidth = desktop.greaterThan ? 5 : colWidth;
  const accordionsColumnWidth = desktop.greaterThan ? 7 : 12;

  return (
    <div css={styles.wrapper}>
      <Spacer height={phoneLarge.lessThan ? "one" : "oneHalf"} />
      <Columns isMarginless css={styles.container}>
        <Column isPaddingless columnWidth={imageColumnWidth}>
          <Skeleton type="image" imageSize="fill" css={styles.skeletonImage} />
        </Column>
        <Column isPaddingless columnWidth={productInfoColWidth} css={styles.infoContainer.base}>
          <Arrange spacing="large" isFullWidth isVertical>
            <Arrange spacing="large" isFullWidth>
              <Arrange spacing="xxsmall" isVertical isFullWidth>
                <Skeleton type="typography" isFullWidth />
                <Skeleton type="typography" />
              </Arrange>
              <Columns preserveMobileColumns isMarginless>
                <Column isPaddingless columnWidth={6}>
                  <Arrange spacing="xsmall" isVertical>
                    <Typography isMarginless>{t(l.productDetails.EmersonItemCode)}</Typography>
                    <Skeleton type="typography" />
                  </Arrange>
                </Column>
                <Column isPaddingless columnWidth={6}>
                  <Arrange alignment="start" spacing="xsmall" isVertical>
                    <Typography isMarginless>{t(l.productDetails.VendorItemCode)}</Typography>
                    <Skeleton type="typography" />
                  </Arrange>
                </Column>
              </Columns>
            </Arrange>
            <SkeletonProductActions />
          </Arrange>
        </Column>
      </Columns>
      <Spacer height={tablet.greaterThan ? "doubleHalf" : "oneHalf"} />
      <Columns isMarginless>
        <Column isPaddingless columnWidth={accordionsColumnWidth}>
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton
              type="typography"
              typographySize="body"
              isFullWidth
              margin="bottom"
              height={3}
              key={index}
            />
          ))}
        </Column>
      </Columns>

      <Spacer height="quad" />
    </div>
  );
};

export { SkeletonSingleProductDetails };
